import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Forms from "../../../../Componets/Form";
import toast from "react-hot-toast";
import Header from "../../../../Componets/Header";
import {
  create_invoice,
  get_invoice,
  update_invoice,
} from "../../../../Controllers/Sales/Invoices";
import forms from "../../../../Data/Forms/Sales/Invoices/forms";
import headers from "../../../../Data/Forms/Sales/Invoices/headers";
import Loadercomponent from "../../../../Componets/Loader";
import Bodycomponent from "../../../../Componets/Formcomponents/body";
import Titlecomponent from "../../../../Componets/Formcomponents/title";
import Formdata from "../../../../Componets/Formcomponents/formdata";
import Headercomponent from "../../../../Componets/Formcomponents/header";
import Invoicetable from "../../../../Data/Forms/Sales/Invoices/table";
import dayjs from "dayjs";

const InvoicesForm = () => {
  let { id } = useParams();
  let navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [values, setValues] = useState(forms);

  const focus = useRef([]);

  const [details, setDetails] = useState([
    {
      id: "",
      description: null,
      name: "",
      unit: "",
      unit_name: "",
      unit_details_options: null,
      conversion: 0,
      quantity: "",
      invoice: "",
      invoice_price: "",
      invoice_options: null,
      delivered: "",
      tax: 0,
      free: "",
      barcode: "",
      price_per_unit: "",
      discounted_price: "",
      discounted_percentage: "",
      sale_price: "",
      expiry_date: "",
      tax_amount: "0.000",
      total: 0,
    },
  ]);

  const [totals, setTotals] = useState({
    subtotal: "0.000",
    taxamount: "0.000",
    discount: 0,
    discount_value: 0,
    discount_type: 0,
    delivery: 0,
    delivery_status: 2,
    delivery_date: dayjs(),
    payment_status: 2,
    payment_types: ["Cash"],
    /*  payments: {
       Cash: "",
       "Debit card": "",
       "Credit card": "",
       "Bank transfer": "",
       "Online payment": "",
       Cheque: "",
     }, */
    payments: [{
      id: `temp-cash-initial`,
      name: "Cash",
      amount: ""
    }],
    paid: 0,
    remaining: 0,
    total: "0.000",
  });

  const detailsvalidation = (tabledata) => {
    let params = {};

    if (details?.length > 0) {
      let total = details?.length;
      let count = 0;

      let validated = [];
      details?.map((v, i) => {
        if (count == i) {
          if (!v?.description) {
            document.getElementById(
              `description${i}`
            ).textContent = `Description is required`;
            focus.current[`description${i}`].current.focus();
          } else if (!v?.sale_price) {
            document.getElementById(
              `sale_price${i}`
            ).textContent = `Sale price is required`;
            focus.current[`sale_price${i}`].current.focus();
          } else if (!v?.quantity) {
            document.getElementById(
              `quantity${i}`
            ).textContent = `Quantity is required`;
            focus.current[`quantity${i}`].current.focus();
          } else {
            document.getElementById(`description${i}`).textContent = ``;
            document.getElementById(`sale_price${i}`).textContent = ``;
            document.getElementById(`quantity${i}`).textContent = ``;

            validated?.push(v);
            count++;
          }
        }
      });

      if (count == total) {
        params = {
          status: true,
          data: {
            ...tabledata,
            details: validated,
          },
        };

        return params;
      } else {
        params = {
          status: false,
          data: null,
        };

        return params;
      }
    } else {
      toast?.error("Details not found");
    }
  };

  const totalsvalidation = (tabledata) => {
    let params = {};

    let count_totals = 0;

    if (totals?.delivery_status == 2 && !totals?.delivery_date) {
      document.getElementById(
        `delivery_date`
      ).textContent = `Delivery Date is required`;
      focus.current[`delivery_date`].current.focus();
    } else if (totals?.payment_status && !totals?.payment_types?.length) {
      document.getElementById(
        `payment_types`
      ).textContent = `Payment type is required`;
      focus.current[`payment_types`].current.focus();
    } else {
      if (totals?.delivery_status == 2) {
        document.getElementById(`delivery_date`).textContent = ``;
      }
      if (totals?.payment_status) {
        document.getElementById(`payment_types`).textContent = ``;
      }
      count_totals++;
    }

    if (count_totals) {
      let total_payment_types = totals?.payment_types?.length;
      let count_payment_types = 0;

      let total_amount = 0;
      if (totals?.payment_types?.length > 0) {
        /* totals?.payment_types?.map((v, i) => {
          if (count_payment_types == i) {
            if (!totals?.payments?.[v]?.amount) {
              document.getElementById(`${v}`).textContent = `${v} is required`;
              focus.current[`${v}`].current.focus();
            } else {
              total_amount =
                parseFloat(total_amount || 0) +
                parseFloat(totals?.payments?.[v]?.amount || 0);
              document.getElementById(`${v}`).textContent = ``;
              count_payment_types++;
            }
          }
        }); */

        totals?.payment_types?.forEach((type, i) => {
          const paymentsOfType = totals?.payments?.filter(p => p.name === type);
          const hasValidPayment = paymentsOfType?.some(p => p.amount && parseFloat(p.amount) > 0);

          if (!hasValidPayment) {
            document.getElementById(`payment_type_${type}`).textContent = `${type} payment is required`;
            focus.current[`payment_type_${type}`]?.current?.focus();
          } else {
            const typeTotal = paymentsOfType.reduce(
              (sum, p) => sum + parseFloat(p.amount || 0),
              0
            );

            total_amount += typeTotal;
            document.getElementById(`payment_type_${type}`).textContent = ``;
            count_payment_types++;
          }
        });

        console.log("totoal amount", total_amount)

        if (total_amount == 0 && !tabledata?.customer) {
          toast?.error("Customer required for credit");
        }
        // else if (total_amount > 0 && total_amount < totals?.total) {
        //   toast?.error("Partial payment not allowed");
        // }
        else {
          if (count_payment_types == total_payment_types) {
            params = {
              status: true,
              data: {
                ...tabledata,
                id: id ? id : "",
                subtotal: totals?.subtotal,
                taxamount: totals?.taxamount,
                discount_value: totals?.discount_value,
                discount_type: totals?.discount_type,
                discount: totals?.discount,
                delivery: totals?.delivery,
                delivery_status: totals?.delivery_status,
                delivery_date: totals?.delivery_date,
                payment_status: totals?.payment_status,
                payment_types: totals?.payment_types,
                payments: totals?.payments,
                total: totals?.total,
              },
            };
            return params;
          } else {
            params = {
              status: false,
              data: null,
            };

            return params;
          }
        }
      } else {
        params = {
          status: true,
          data: {
            ...tabledata,
            id: id ? id : "",
            subtotal: totals?.subtotal,
            taxamount: totals?.taxamount,
            discount_value: totals?.discount_value,
            discount_type: totals?.discount_type,
            discount: totals?.discount,
            delivery: totals?.delivery,
            delivery_status: totals?.delivery_status,
            delivery_date: totals?.delivery_date,
            payment_status: totals?.payment_status,
            payment_types: totals?.payment_types,
            payments: totals?.payments,
            total: totals?.total,
          },
        };

        return params;
      }
    }
  };

  const formdata = async (data) => {
    if (data?.status) {

      if (buttonLoader) return;

      const tabledetailsvalidation = detailsvalidation(data?.data);

      if (tabledetailsvalidation?.status) {
        const tabletotalvalidation = totalsvalidation(
          tabledetailsvalidation?.data
        );

        if (tabletotalvalidation?.status) {
          setButtonLoader(true);

          const normalizedPayments = tabletotalvalidation.data.payments
            .filter(p => p.amount && parseFloat(p.amount) > 0)
            .map(p => ({
              ...p,
              amount: parseFloat(p.amount)
            }));

          const payload = {
            ...tabletotalvalidation.data,
            payments: normalizedPayments
          };

          const invoice = id
            ? await update_invoice(payload)
            : await create_invoice(payload);
          if (invoice?.status) {
            // if (id) {
            navigate(-1);
            // }

            toast?.success(invoice?.message);
            setButtonLoader(false);
          } else {
            setButtonLoader(false);
            if (invoice?.status_code == 403) {
              window.location.href = "/unauthorized";
            } else {
              toast?.error(invoice?.message);
            }
          }
        }
      }
    }
  };

  const handleData = (invoice) => {
    let customer = invoice?.customer?._id ? invoice?.customer?._id : null;
    let number = invoice?.number ? invoice?.number : "";
    let date = invoice?.date ? invoice?.date : "";
    let due_date = invoice?.due_date ? invoice?.due_date : "";
    let lpo_number = invoice?.lpo_number ? invoice?.lpo_number : "";
    let lpo_date = invoice?.lpo_date ? invoice?.lpo_date : "";
    let salesman = invoice?.salesman?._id ? invoice?.salesman?._id : null;
    let status = invoice?.status ? invoice?.status : 0;

    let salesman_options = invoice?.salesman?._id
      ? [
        {
          value: invoice?.salesman?._id,
          label: invoice?.salesman?.name,
        },
      ]
      : null;

    let customer_option = invoice?.customer?._id
      ? [
        {
          value: invoice?.customer?._id,
          label:
            invoice?.customer?.name && invoice?.customer?.phone
              ? invoice?.customer?.name +
              " (" +
              invoice?.customer?.phone +
              ")"
              : invoice?.customer?.name
                ? invoice?.customer?.name
                : invoice?.customer?.phone
                  ? invoice?.customer?.phone
                  : "",
        },
      ]
      : null;

    values[0].options[0].form.value = customer;
    values[0].options[0].form.options = customer_option;
    values[0].options[1].form.value = number;
    values[0].options[2].form.value = date;
    values[0].options[3].form.value = due_date;
    values[0].options[4].form.value = lpo_number;
    values[0].options[5].form.value = lpo_date;

    values[0].options[6].form.value = salesman;
    values[0].options[6].form.options = salesman_options;

    values[0].options[7].form.value = status;

    let data = [];

    invoice?.details?.map((value, index) => {
      let stock = value?.description?.stock;

      if (value?.unit != value?.description?._id) {
        value?.inventory_unit_details?.map((v, i) => {
          if (value?.unit == v?._id) {
            stock = v?.stock;
          }
        });
      }

      data?.push({
        id: value?._id,
        description: value?.description?._id,
        batch: value?.description?.number,
        expiry_date: value?.description?.expiry_date,
        stock: stock,
        name: value?.name,
        unit: value?.unit,
        unit_name: value?.unit_name,
        unit_details_options: value?.unit_details_options,
        conversion: value?.conversion,
        invoice_price: value?.invoice_price,
        quantity: value?.quantity,
        delivered: value?.delivered,
        free: value?.free,
        tax_details: value.tax ? value.tax : null,
        tax: value?.tax?.name ? value?.tax?.name : null,
        barcode: value?.barcode,
        price_per_unit: value?.price_per_unit,
        sale_price: value?.sale_price,
        discount_price: value?.discount_price,
        discount_percentage: value?.discount_percentage,
        retail_price: value?.description?.product?.sale_price,
        expiry_date: value?.expiry_date,
        tax_amount: value?.tax_amount,
        total: value?.total,
      });
    });

    let payment_types = [];
    let payments = [];

    invoice?.payments?.forEach((payment) => {
      if (!payment_types.includes(payment?.name)) {
        payment_types.push(payment?.name);
      }

      payments.push({
        id: payment?._id || `temp-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
        name: payment?.name,
        amount: payment?.amount
      });
    });

    totals.subtotal = invoice?.subtotal;
    totals.taxamount = invoice?.taxamount;
    totals.discount_value = invoice?.discount_value;
    totals.discount_type = invoice?.discount_type;
    totals.discount = invoice?.discount;
    totals.delivery = invoice?.delivery;
    totals.delivery_status = invoice?.delivery_status;
    totals.delivery_date = invoice?.delivery_date;
    totals.payment_status = invoice?.payment_status;
    totals.payment_types = payment_types;
    totals.payments = payments;
    totals.total = invoice?.total;

    setValues([...values]);
    setDetails([...data]);
    setTotals({ ...totals });
    setLoader(false);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);
      console.log("id", id)

      const data = {
        id: id,
      };

      const invoice = await get_invoice(data);
      if (invoice?.status) {
        handleData(invoice?.data);
      } else {
        toast?.error(invoice?.message);
      }
    } else {
      values[0].options[2].form.value = new Date();
      // values[0].options[3].form.value = new Date();

      totals.delivery_status = 2;
      totals.delivery_date = new Date();
      totals.payment_status = 2;

      setValues([...values]);
      setTotals({ ...totals });
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  /*   useEffect(() => {
      if (id) {
        const updatedValue = values.forEach(section => {
          section.options.forEach(field => {
            if (field.form && field.form.disabled !== undefined) {
              field.form.disabled = true;
            }
          });
        });
  
        setValues(updatedValue);
      }
    }, [id]);
  
    useEffect(() => {
      if (!id) {
        const updatedValues = values.map(section => {
          return {
            ...section,
            options: section.options.map(field => {
              if (field.form && field.form.disabled === true) {
                return {
                  ...field,
                  form: {
                    ...field.form,
                    disabled: false
                  }
                };
              }
              return field;
            })
          };
        });
  
        setValues(updatedValues);
      }
    }, [values]); */


  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Forms
          form={values}
          setForm={setValues}
          formdata={formdata}
          buttonLoader={buttonLoader}
        >
          <Bodycomponent>
            <Titlecomponent index={1} title={"Items"} />
            <Formdata>
              <Headercomponent index={0} name={"Details"} required={true} />
              <Invoicetable
                details={details}
                setDetails={setDetails}
                totals={totals}
                setTotals={setTotals}
                ref={focus}
              />
            </Formdata>
          </Bodycomponent>
        </Forms>
      </Loadercomponent>
    </Header>
  );
};

export default InvoicesForm;
